module.exports = __webpack_public_path__ + "fonts/iconfont.beb10e6.woff2";